import * as t from 'io-ts';
import { IPublicStatusComplaintItem } from 'ws-voice-infinity-global-module/lib/interfaces';
import PUBLIC_STATUS_COMPLAINT, { PublicStatusComplaintType } from '../enums/publicStatusComplaint';

export const ComplaintStatisticType = t.interface({
    publicStatus: PublicStatusComplaintType,
    count: t.number,
});

export interface ComplaintStatisticDTO extends t.TypeOf<typeof ComplaintStatisticType> {}

export class ComplaintStatistic {
    publicStatus: IPublicStatusComplaintItem;
    count: number;

    constructor(params: ComplaintStatisticDTO) {
        this.publicStatus = PUBLIC_STATUS_COMPLAINT[params.publicStatus];
        this.count = params.count;
    }
}
